import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { workflowsApi } from "@/react/api";
import { useSetInitialNodeTypeAndIsOpen } from "@circle-react-shared/WorkflowsV2/Canvas/workflowStore";
import { useToast } from "@circle-react-uikit/ToastV2";
import { workflowsSettingsPaths } from "../helpers/urlHelpers/workflowsSettingsPaths";

const i18nRoot = "settings.workflows.template_summary";

export const useCreateWorkflow = ({
  templateKey,
  isAutomationWorkflow = false,
}: {
  templateKey: string;
  isAutomationWorkflow?: boolean;
}) => {
  const { error } = useToast();
  const history = useHistory();
  const setInitialNodeTypeAndIsOpen = useSetInitialNodeTypeAndIsOpen();

  const { mutate: createFromTemplate, isLoading } = useMutation(
    () => workflowsApi.createFromTemplateKey({ templateKey }),
    {
      onSuccess: ({ id }) => {
        history.push(workflowsSettingsPaths.edit({ workflowId: id }));

        const initialNodeType = isAutomationWorkflow ? "trigger" : "audience";
        setInitialNodeTypeAndIsOpen(initialNodeType);
      },
      onError: () => {
        error(t([i18nRoot, "there_was_an_error_creating_your_workflow"]));
      },
    },
  );

  return { createFromTemplate, isLoading };
};
